import { render, staticRenderFns } from "./BoardRegister.vue?vue&type=template&id=086fb1bc&scoped=true"
import script from "./BoardRegister.vue?vue&type=script&lang=js"
export * from "./BoardRegister.vue?vue&type=script&lang=js"
import style0 from "./BoardRegister.vue?vue&type=style&index=0&id=086fb1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086fb1bc",
  null
  
)

export default component.exports